import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { ConfirmService }           from '../messages/confirm/confirm.service';
import { ProlinkSettingsModel }     from './typings/prolink.settings';
import { withoutBlankPassword }     from '../companies/company.supplier-password';

@Injectable({
  providedIn: 'root'
})
export class ProlinkService {
  title = 'PROLink';

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  activate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/add_prolink'));
  }

  deactivate () : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
      name: this.title
    }))
    .then(() => this.apiService.get('/company/remove_prolink'));
  }

  save ( settings : ProlinkSettingsModel, companySettings : CompanyIntegrationsModel ) : ng.IPromise<CompanyIntegrationsModel> {
    return this.apiService.patch('/company', withoutBlankPassword(settings, 'prolink_password'), 'company')
    .then(() => this.apiService.patch('/company_integrations', companySettings, 'company_integration'));
  }
}
